import {  createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { HomeExtraReducer } from './homeThunk';

// const msgKey = 'home';

export interface HomeState {
  username: String,
  token: String,
  consts: any,
}

const initialState: HomeState = {
  username: localStorage.getItem('username') || 'Unknown',
  token: localStorage.getItem('token') || '',
  consts: {},
};

// export const loginAsync = createAsyncThunk(
//   'login/userLogin',
//   async (body: any) => {
//     return await login(body);
//   }
// );

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setUsername: (state, {payload})=> {state.username = payload},
    setToken: (state, {payload})=> {state.token = payload}
  },
  extraReducers: HomeExtraReducer,
});

export const { setUsername, setToken } = homeSlice.actions;

export const selectConsts = (state: RootState) => state.home.consts;
export const selectUsername = (state: RootState) => state.home.username;
export const selectToken = (state: RootState) => state.home.token;

export default homeSlice.reducer;
